import { removeLastSlash, removeLinkParams } from './link';
var baseDeezerPath = 'deezer.com/';
var baseEmbeddedPath = 'https://widget.deezer.com/widget/auto/';
var createEmbeddedLink = function (link) {
    var _a;
    var paths = (_a = removeLastSlash(removeLinkParams(link))) === null || _a === void 0 ? void 0 : _a.split(baseDeezerPath)[1].split('/');
    var finalPath = paths && paths.length > 1
        ? paths[paths.length - 2] + "/" + paths[paths.length - 1]
        : undefined;
    var isArtist = finalPath === null || finalPath === void 0 ? void 0 : finalPath.startsWith('artist/');
    return finalPath
        ? "" + baseEmbeddedPath + finalPath + (isArtist ? '/top_tracks' : '') + "?tracklist=true"
        : undefined;
};
export var deezer = {
    category: 'AUDIO',
    isSatisfied: function (link) { return link.includes(baseDeezerPath); },
    getPlayerExecutionProps: function (link) { return ({
        link: createEmbeddedLink(link),
        allowProps: 'encrypted-media; clipboard-write',
        responsive: true,
        height: 300,
    }); },
};
